/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

/**
 * @module carousel-transition/bulbcarouseltransitionCommand
 */

import { Command, type ModelWriter } from 'ckeditor5';

/**
 * The BulbCarouselTransitionCommand will be called on transition selection for image carousel.
 *
 * @extends Command
 */
export class BulbCarouselTransitionCommand extends Command {

  /**
   * @inheritDoc
   *
   * @param bulbCarouselTransition Transition update.
   */
  public override execute(bulbCarouselTransition): void {
    const carouselBlock = this.editor.model.document.selection.getSelectedElement();
    this.editor.model.change((writer: ModelWriter) => {
      if (bulbCarouselTransition) {
        writer.setAttribute('bulbCarouselTransition', bulbCarouselTransition, carouselBlock);
      }
    });

    // Send event image carousel to update transition
    window.dispatchEvent(new CustomEvent('imageCarouselTransitionUpdate', {
      detail: {
        effect: bulbCarouselTransition,
        blockId: carouselBlock.getAttribute('bulb-block-id'),
      },
    }));
  }

  /**
   * @inheritDoc
   */
  public override refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;
    const selectedElement = selection.getSelectedElement();
    if (selectedElement) {
      this.value = selectedElement.getAttribute('bulbCarouselTransition');
    }
    const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'imageCarousel');

    this.isEnabled = allowedIn !== null;
  }
}
